module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA1ElEQVQ4jZWRUW7EMAhEH1XuFd/M+GbkZNOPLlnsZKPtSBY2hmEAA5BExRhjcvTejSdIQhLuLneXpNPm/fVmPQBTYiYAighFxCPRVmSm/FNZRNBa4ziONUbZmqWC1hoA+74DYGa4OwD5l6gxGwuyWvZXFdXk9G8pZYyhWsnG3+DVLxua3hcFAC0a0WIiihZExCX25y652k9wdyTZhSArV5v3O5wEvXdbJX6j5qIgq37bisF7ZWYm4BxWHWb1Z/+wbCGdK9ETbtf4H6KphY9BL6K1AMAvfIfL2S4v6yAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/RECYCLED_16.png
// module id = 92
// module chunks = 0